import { useMemo } from 'react';

const parseNumberQueryParam = (value: string | null) => {
  if (value === null || value === '') {
    return undefined;
  }

  const parsed = Number(value);
  return Number.isNaN(parsed) ? undefined : parsed;
};

export default function useQueryParams<T>() {
  const queryParams = useMemo(
    () => new URLSearchParams(window.location.search),
    [window.location.search],
  );
  return {
    page: parseNumberQueryParam(queryParams.get('page')),
    perpage: parseNumberQueryParam(queryParams.get('perpage')),
    fp: queryParams.get('fp') === 'true',
    floor: parseNumberQueryParam(queryParams.get('floor')),
    filters: String(queryParams.get('filters') || ''),
  };
}
